import { find as _find } from 'lodash';
import { without as _without } from 'lodash';
import { filter as _filter } from 'lodash';
import { sum as _sumBy } from 'lodash';
import EditEnquiryPrice from './editEnquiryPrice.modal.html';
import EditEnquiryPayment from './editEnquiryPayment.modal.html';
import EditEnquiryNotes from './editEnquiryNotes.modal.html';

class EnquiryPricingController {
  constructor(enums, $scope, $uibModal, lookupService, authService, addEditFinancialProductService, addEditEnquiryExtraService, $state, printService, adminService, $ngConfirm, enquiryService, growl) {
    "ngInject";

    this.enums = enums;
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.lookupService = lookupService;
    this.authService = authService;
    this.addEditFinancialProductService = addEditFinancialProductService;
    this.addEditEnquiryExtraService = addEditEnquiryExtraService;
    this.$state = $state;
    this.printService = printService;
    this.adminService = adminService;
    this.$ngConfirm = $ngConfirm;
    this.enquiryService = enquiryService;
    this.growl = growl;

    this.amountToPay = 0;
    this.totalPrice = 0;
    this.totalDiscount = 0;
    this.balanceDue = 0;

    this.priceTypes = this.convertEnumToKeyValueList(enums.ENQUIRY_PRICE_TYPE, true);
    this.paymentModes = this.convertEnumToKeyValueList(enums.ENQUIRY_PAYMENT_MODE, true);

    this.defaultTexts = {};

    //lookupService.lookupEnquiryPrices(this.authService.authData.currentLocation.key)
      //.then((defaultPrices) => {
        //this.defaultPrices = defaultPrices;

        $scope.$on('vehicleSelected', this.initializePrices.bind(this));
        $scope.$on('enquiry:initialized', this.enquiryInitialized.bind(this));

        this.vehicleCost = 0;
        this.tradeInAllowance = 0;
        this.loadDefaultTexts();
      //});

      this.breakdownSummary = {
        finance: 0,
        cash: 0,
        eft: 0,
        cheque: 0,
        total: 0        
      };
  }

  enquiryInitialized() {
    const ctrl = this;

    ctrl.lookupService.lookupEnquiryPrices(this.authService.authData.currentLocation.key)
      .then((defaultPrices) => {        
        ctrl.defaultPrices = defaultPrices;

        ctrl.loadDefaultPrices();
        ctrl.initializePrices();
        
        ctrl.$scope.$emit('enquiryPricing:initialized', {amountToPay: ctrl.amountToPay, balanceDue: ctrl.balanceDue});
      });
  }

  loadDefaultPrices() {
    this.defaultPrices.enquiryExtras.map(item => {
      this.addPrice(item.name, this.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras, item.defaultPrice, item.reportable);
    });

    this.defaultPrices.financialProducts.map(item => {
      this.addPrice(item.name, this.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts, item.defaultPrice, item.reportable);
    });
  }

  addPrice(name, groupType, amount, reportable) {
    const ctrl = this;
    const priceField = _find(ctrl.enquiry.enquiryPrices, o => o.groupType === groupType && o.name === name);
    if (!priceField) {
      ctrl.enquiry.enquiryPrices.push({
        priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
        groupType: groupType,
        name: name,
        amount: amount || 0,
        reportable: reportable || false,
        removed: false
      });
    }
  }

  convertEnumToKeyValueList(enumObj, defaultOption) {
    let objList = [];

    if (defaultOption) {
      objList.push({
        id: null,
        name: 'Please Select'
      })
    }

    for(let prop in enumObj){
      objList.push({
        id: enumObj[prop],
        name: prop
      });
    }

    return objList;
  }

  initializePrices() {
    const ctrl = this;
    let vehicle;

    //Get the selected Vehicle if there is one
    const enquiryVehicle = _find(ctrl.enquiry.enquiryVehicles, o => o.isSelected);

    let vehicleCostPrice = _find(ctrl.enquiry.enquiryPrices, o => o.name === 'Vehicle Price');

    if (!vehicleCostPrice) {
      ctrl.enquiry.enquiryPrices.push({
        priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
        groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
        name: 'Vehicle Price',
        amount: 0
      });

      vehicleCostPrice = _find(ctrl.enquiry.enquiryPrices, o => o.name === 'Vehicle Price');
    }
    else {
      /*
      * #726
      * The vehicle price was not getting updated after a vehicle selection was updated
      */
      vehicleCostPrice.amount = enquiryVehicle.vehicle.price;
    }

    if (enquiryVehicle) {
      vehicle = enquiryVehicle.vehicle;

      if (!vehicleCostPrice.amount && vehicle) {
        vehicleCostPrice.amount = vehicle.price || 0;
      }
    }

    let allowancePrice = _find(ctrl.enquiry.enquiryPrices, o => o.name === 'Trade In Allowance(s)');

    if (!allowancePrice) {
      ctrl.enquiry.enquiryPrices.push({
        priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Discount,
        groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
        name: 'Trade In Allowance(s)',
        amount: 0
      });

      allowancePrice = _find(ctrl.enquiry.enquiryPrices, o => o.name === 'Trade In Allowance(s)');
    }

    //Get the enquiry trade in if any
    allowancePrice.amount = 0;
    ctrl.enquiry.tradeInVehicles.map(v => {
      allowancePrice.amount += v.allowance;
    });

    ctrl.updateCalculations();
  }

  updateCalculations() {
    const ctrl = this;
    let tempPrice = 0;

    /*
    * Prices should only have a value if there is a Vehicle Selected
    * in Enquiry. Otherwise default prices for new Enquiry will show up
    * without any vehicles which will look odd
    */
    if (!ctrl.enquiry.enquiryVehicles.length) { return; }

    ctrl.totalPrice = 0;
    ctrl.totalDiscount = 0;

    ctrl.enquiry.enquiryPrices.map(price => {
      if (price.removed) {
        return;
      }

      if (price.priceType === ctrl.enums.ENQUIRY_PRICE_TYPE.Cost) {
        ctrl.totalPrice += price.amount;
      }
      else {
        ctrl.totalDiscount += price.amount;
      }
    });

    ctrl.amountToPay = ctrl.totalPrice - ctrl.totalDiscount;
    ctrl.balanceDue = ctrl.totalPrice - ctrl.totalDiscount;

    ctrl.balanceDue -= (ctrl.enquiry.deposit || 0);

    //Update Breakdown Summary
    ctrl.breakdownSummary.finance = ctrl.getEnquiryPaymentSummary(ctrl.enums.ENQUIRY_PAYMENT_MODE.Finance);
    ctrl.breakdownSummary.eft = ctrl.getEnquiryPaymentSummary(ctrl.enums.ENQUIRY_PAYMENT_MODE.EFT);
    ctrl.breakdownSummary.cheque = ctrl.getEnquiryPaymentSummary(ctrl.enums.ENQUIRY_PAYMENT_MODE.Cheque);
    ctrl.breakdownSummary.cash = ctrl.getEnquiryPaymentSummary(ctrl.enums.ENQUIRY_PAYMENT_MODE.Cash);
    ctrl.breakdownSummary.total = ctrl.getEnquiryPaymentTotal();
  }

  editEnquiryPrice(enquiryPrice) {
    this.errMsg = '';
    this.saveButtonTitle = 'Add';

    if (enquiryPrice) {
      this.tempEnquiryPrice = enquiryPrice;
      this.tempEnquiryPrice.editMode = true;
      this.saveButtonTitle = 'Update';
    }
    else {
      this.tempEnquiryPrice = {
        priceType: this.enums.ENQUIRY_PRICE_TYPE.Discount,
        groupType: this.enums.ENQUIRY_PRICE_GROUP_TYPE.Misc
      };
    }

    this.$uibModalInstance = this.$uibModal.open({
        template: EditEnquiryPrice,
        scope: this.$scope
    });
  }

  closeModal() {
    this.$uibModalInstance.close();
  }

  addEnquiryPrice() {
    const ctrl = this;

    if (!ctrl.tempEnquiryPrice.name) {
      ctrl.errMsg = 'Please enter a Name First';
      return;
    }

    const floatPattern = new RegExp(`^-?\\d*(\\.\\d{0,10})?$`);

    if (!floatPattern.exec(ctrl.tempEnquiryPrice.amount) || parseFloat(ctrl.tempEnquiryPrice.amount) <= 0) {
      ctrl.errMsg = 'Please enter amount as a valid floating point number above 0';
      return;
    }

    const enquiryPrice = _find(ctrl.enquiry.enquiryPrices, o => !o.editMode
      && o.groupType === ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.Misc
      && o.name.toLowerCase() === ctrl.tempEnquiryPrice.name.toLowerCase());

    if (enquiryPrice) {
      ctrl.errMsg = 'This Price has already been recorded';
      return;
    }

    if (!ctrl.tempEnquiryPrice.editMode) {
      ctrl.enquiry.enquiryPrices.push(ctrl.tempEnquiryPrice);
    }
    else {
      ctrl.tempEnquiryPrice.editMode = false;
    }

    ctrl.updateCalculations();
    ctrl.closeModal();
  }

  removeEnquiryPrice(enquiryPrice) {
    switch(enquiryPrice.groupType){
      case this.enums.ENQUIRY_PRICE_GROUP_TYPE.Misc:
        this.enquiry.enquiryPrices = _without(this.enquiry.enquiryPrices, enquiryPrice);
        break;

      case this.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras:
      case this.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts:
        enquiryPrice.removed = true;
        break;
    }

    this.updateCalculations();
  }

  editEnquiryPayment(enquiryPayment) {

    if (this.enquiry.enquiryVehicles.length === 0) {
      this.$ngConfirm({
        title: null,
        content: `Please select a vehicle first`,
        typeAnimation: false,
        columnClass: 'm',
        type: 'red',
        scope: this.$scope,
        buttons: {
          ok: {
            text: 'Ok',
            btnClass: 'btn-default'
          }          
      }
      });

      return;
    }

    this.errMsg = '';
    this.saveButtonTitle = 'Add';

    if (enquiryPayment) {
      this.tempEnquiryPayment = enquiryPayment;
      this.tempEnquiryPayment.timeStamp = new Date(this.tempEnquiryPayment.timeStamp);
      this.tempEnquiryPayment.editMode = true;
      this.saveButtonTitle = 'Update';
    }
    else {
      this.tempEnquiryPayment = {
        paymentMode: null,
        paymentForDeposit: true
      };
    }

    this.$uibModalInstance = this.$uibModal.open({
        template: EditEnquiryPayment,
        scope: this.$scope
    });
  }

  addEnquiryPayment() {
    const ctrl = this;

    if (!ctrl.tempEnquiryPayment.paymentMode) {
      ctrl.errMsg = 'Please select a Payment Mode First';
      return;
    }

    if (!this.tempEnquiryPayment.timeStamp) {
      this.errMsg = 'Please select a Date First';
      return;
    }

    const floatPattern = new RegExp(`^-?\\d*(\\.\\d{0,10})?$`);

    if (!floatPattern.exec(ctrl.tempEnquiryPayment.amount) || parseFloat(ctrl.tempEnquiryPayment.amount) <= 0) {
      ctrl.errMsg = 'Please enter amount as a valid floating point number above 0';
      return;
    }

    ctrl.tempEnquiryPayment.paymentModeName = _find(ctrl.paymentModes, o => o.id === ctrl.tempEnquiryPayment.paymentMode).name;

    if (!ctrl.tempEnquiryPayment.editMode) {
      this.enquiryService.addPayment(this.enquiry.enquiryId, ctrl.tempEnquiryPayment)
        .then(response => {
          ctrl.tempEnquiryPayment.enquiryPaymentId = response.data;
          ctrl.enquiry.enquiryPayments.push(ctrl.tempEnquiryPayment);

          ctrl.updateCalculations();
          ctrl.closeModal();          

          this.growl.success('Payment added successfully', {ttl: 5000});
        });
    }
    else {
      this.enquiryService.editPayment(ctrl.tempEnquiryPayment)
        .then(response => {

          ctrl.updateCalculations();
          ctrl.closeModal();
          
          ctrl.tempEnquiryPayment.editMode = false;

          this.growl.success('Payment updated successfully', {ttl: 5000});
        });            
    }
  }

  addEnquiryExtra(complimentary) {
    this.addNewItem(this.addEditEnquiryExtraService, this.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras, complimentary);
  }

  addFinancialProduct() {
    this.addNewItem(this.addEditFinancialProductService, this.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts);
  }

  addNewItem(svc, groupType, complimentary = false){
    const ctrl = this;

    svc.showAdd([], (newItem) => {      
      ctrl.enquiry.enquiryPrices.push({
        priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
        groupType: groupType,
        name: newItem.name,
        amount: newItem.defaultPrice || 0,
        complimentary: complimentary,
        reportable: newItem.reportable,
        removed: false
      });

      ctrl.updateCalculations();
      ctrl.$scope.$emit('enquiryPricing:initialized', {amountToPay: ctrl.amountToPay, balanceDue: ctrl.balanceDue});
    }, true, complimentary);
  }

  updateDeposit() {
    const ctrl = this;
    let deposit = ctrl.enquiry.deposit || 0;

    try {      
      deposit = window.prompt('Please enter a value for Deposit', deposit);      
      if (deposit === '' || parseInt(deposit) === 0 || isNaN(parseInt(deposit))) {
        deposit = 0;
      }
      else {
        deposit = parseInt(deposit);
      }   

      ctrl.enquiry.deposit = deposit;
    }
    catch(e) {
      ctrl.enquiry.deposit = ctrl.enquiry.deposit || 0;
    }

    ctrl.updateCalculations();
  }  

  updateValue(priceName, groupType, amount) {
    const ctrl = this;
    let value = 0;

    try {
      value = parseInt(window.prompt('Please enter a value for ' + priceName, amount > 0 ? amount : ''));
    }
    catch(e) {
      value = 0;
    }

    if (value >= 0) {
      const enquiryPrice = _find(ctrl.enquiry.enquiryPrices, o => o.groupType === groupType && o.name === priceName);

      enquiryPrice.amount = value;

      ctrl.updateCalculations();
    }
  }

  editNotes(noteType, modelProp) {
    this.errMsg = '';
    this.noteType = noteType    
    this.modelProp = modelProp;

    if (this.noteType === 'Warranty') {
      this.presetTexts = this.defaultTexts.warranty;
      this.modalHeader = 'Update Warranty Notes';
    }
    else {
      this.presetTexts = this.defaultTexts.finance;
      this.modalHeader = 'Update Finance Notes';
    }

    this.presetTexts = _filter(this.presetTexts, o => o !== '');

    this.$uibModalInstance = this.$uibModal.open({
        template: EditEnquiryNotes,
        scope: this.$scope
    });    
  }

  saveNotes() {
    if (this.noteType === 'Warranty') {
      this.enquiry.warrantyNotes = this.modelProp;
    }
    else {
      this.enquiry.financeNotes = this.modelProp;
    }   

    this.$scope.$emit('enquiryPricing:notesUpdated');
    this.closeModal();
  }

  quotation() {
    if (this.enquiry.enquiryVehicles.length) {
      const vehicle = _find(this.enquiry.enquiryVehicles, o => o.isSelected).vehicle;    

      if (!vehicle.price || vehicle.price === 0) {
          this.$ngConfirm({
            title: 'ERROR',
            content: 'Selected vehicle does not have a retail price',
            type: 'red',
            typeAnimation: false,
            columnClass: 'm',
            buttons: {
                tryAgain: {
                    text: 'Close',
                    btnClass: 'btn-danger'
                }
            }
          });        
      }
      else {
        this.printService.printQuotation(this.enquiry.enquiryId);
      }      
    }
  }

  loadDefaultTexts() {
    const ctrl = this;

    ctrl.adminService.listDefaultTexts(ctrl.authService.authData.currentLocation.key)
      .then(response => {
        this.defaultTexts = response.data;
      });
  }  

  editVehiclePrice() {
    const vehicle = _find(this.enquiry.enquiryVehicles, o => o.isSelected).vehicle;    
    
    this.$state.go('vehicleEdit', {
      vehicleId: vehicle.vehicleId,
      origin: {
        source: 'enquiry',
        enquiryId: this.enquiry.enquiryId
      }
    });
  }

  getEnquiryPaymentSummary(paymentMode) {    
    const filteredPayments = _filter(this.enquiry.enquiryPayments, o => o.paymentMode === paymentMode);

    return _sumBy(filteredPayments.map(o => o.amount));
  }

  getEnquiryPaymentTotal() {
    return _sumBy(this.enquiry.enquiryPayments.map(o => o.amount));
  }

  printPaymentReceipt() {
    this.printService.paymentReceipt(this.enquiry.enquiryId, this.authService.authData.userId);
  }

  deleteEnquiryPayment(enquiryPayment){
    const ctrl = this;

    this.$ngConfirm({
      title: null,
      content: `Are you sure you want to remove this payment?`,
      typeAnimation: false,
      columnClass: 'm',
      type: 'red',
      scope: this.$scope,
      buttons: {
        yes: {
            text: 'Remove',
            btnClass: 'btn-danger',
            action: () => { 
                ctrl.enquiryService.deletePayment(enquiryPayment.enquiryPaymentId)
                  .then(response => {
                    debugger;
                    ctrl.enquiry.enquiryPayments = _without(ctrl.enquiry.enquiryPayments, enquiryPayment);
                    ctrl.updateCalculations();
                    ctrl.growl.success('Payment removed successfully', {ttl: 5000});
                  });      
            }
        },
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    });
  }    
}

export default EnquiryPricingController;



// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/enquiryPricing/enquiryPricing.controller.js